var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50047 4.49508C3.37502 4.49508 3.24958 4.44718 3.15393 4.35158L0.144087 1.3417C-0.047378 1.15024 -0.047378 0.839811 0.144087 0.648424C0.335475 0.457036 0.645841 0.457036 0.837322 0.648424L3.50047 3.31173L6.16363 0.648517C6.3551 0.457129 6.66543 0.457129 6.8568 0.648517C7.04836 0.839904 7.04836 1.15033 6.8568 1.3418L3.84701 4.35167C3.75132 4.44729 3.62588 4.49508 3.50047 4.49508Z",
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-down.a7d6004d.svg";
export { ForwardRef as ReactComponent };